import { mockClient } from "./mockClient"

export type DeadLetter = {
  id: number
  schedule_id: number
  job_type: string
  error_message: string
  created_at: string
  requeued_count: number
  last_requeued_at: string | null
  contact: {
    id: number | null
    display_name: string | null
    email: string | null
    phone_number: string | null
    persona: string | null
  }
  tenant: {
    id: number | null
    name: string | null
  }
  payload: Record<string, unknown>
}

export type AdminListResponse<T> = {
  items: T[]
  next_cursor: number | null
}

export type WebhookEventSummary = {
  id: number
  event_id: string
  type: string
  processed_at: string | null
  object_id: string | null
  connected_account: string | null
}

export type AdminTenantSummary = {
  id: number
  name: string
  stripe_account_id: string | null
  application_fee_bps: number
  default_currency: string
  created_at: string
  updated_at: string
}

export async function fetchDeadLetters(
  demo: boolean,
  params: { limit?: number; cursor?: number | null } = {},
  token?: string | null,
): Promise<AdminListResponse<DeadLetter>> {
  return mockClient.getAdminDeadLetters(demo, params, token) as Promise<AdminListResponse<DeadLetter>>
}

export async function requeueDeadLetter(demo: boolean, deadLetterId: number, token?: string | null) {
  return mockClient.requeueDeadLetter(demo, deadLetterId, token)
}

export async function fetchWebhookEvents(
  demo: boolean,
  params: { limit?: number; cursor?: number | null } = {},
  token?: string | null,
): Promise<AdminListResponse<WebhookEventSummary>> {
  return mockClient.getAdminWebhooks(demo, params, token) as Promise<AdminListResponse<WebhookEventSummary>>
}

export async function fetchAdminTenants(
  demo: boolean,
  params: { limit?: number; cursor?: number | null } = {},
  token?: string | null,
): Promise<AdminListResponse<AdminTenantSummary>> {
  return mockClient.getAdminTenants(demo, params, token) as Promise<AdminListResponse<AdminTenantSummary>>
}
